var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKolba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5568 20.7409C46.9638 20.1479 46.2788 19.6822 45.5017 19.3464C44.7219 19.008 43.8826 18.8401 42.9782 18.8401C42.0874 18.8401 41.2508 19.0107 40.4656 19.3464C39.6831 19.6849 38.9926 20.1506 38.3997 20.7409C37.8148 21.3338 37.3572 22.0162 37.0296 22.7933C36.702 23.5676 36.5396 24.407 36.5396 25.3087C36.5396 26.1968 36.702 27.0334 37.0296 27.8159C37.3572 28.5985 37.8148 29.2862 38.3997 29.8792C38.9926 30.4721 39.6831 30.9297 40.4656 31.2547C41.2508 31.5796 42.0874 31.742 42.9782 31.742C43.8853 31.742 44.7219 31.5796 45.5017 31.2547C46.2761 30.9297 46.9638 30.4721 47.5568 29.8792C48.1416 29.2862 48.6046 28.5985 48.9377 27.8159C49.2734 27.0334 49.4386 26.1995 49.4386 25.3087C49.4386 24.407 49.2734 23.5676 48.9377 22.7933C48.6019 22.0162 48.1416 21.3311 47.5568 20.7409ZM47.3348 27.1309C47.0884 27.7049 46.7499 28.2031 46.3275 28.6255C45.9051 29.0479 45.407 29.3864 44.8329 29.6328C44.2616 29.8792 43.6416 30.0037 42.9782 30.0037C42.3284 30.0037 41.7165 29.8792 41.1452 29.6328C40.5712 29.3864 40.073 29.0479 39.6506 28.6255C39.2282 28.2031 38.8897 27.7049 38.6434 27.1309C38.397 26.5596 38.2724 25.9477 38.2724 25.2978C38.2724 24.6345 38.397 24.0144 38.6434 23.4431C38.8897 22.8691 39.2282 22.3709 39.6506 21.9485C40.073 21.5261 40.5712 21.1876 41.1452 20.9412C41.7165 20.6948 42.3284 20.5703 42.9782 20.5703C43.6416 20.5703 44.2616 20.6948 44.8329 20.9412C45.407 21.1876 45.9051 21.5261 46.3275 21.9485C46.7499 22.3709 47.0884 22.8691 47.3348 23.4431C47.5812 24.0144 47.7057 24.6345 47.7057 25.2978C47.7057 25.945 47.5812 26.5596 47.3348 27.1309Z",
    fill: "url(#paint0_linear_552_5687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4123 24.445C67.8474 22.4359 66.6479 19.3573 63.7453 19.0568C63.7426 19.0568 63.4962 19.0459 63.4962 19.0459L59.757 19.0432C59.7327 19.0432 59.7056 19.0432 59.6812 19.0459C59.4511 19.0513 59.2534 19.1353 59.0909 19.3004C58.9231 19.4683 58.8364 19.6741 58.8364 19.9124V30.2502C58.8364 30.4911 58.9204 30.6942 59.0909 30.8621C59.2588 31.03 59.4646 31.1166 59.7029 31.1166H59.7083H59.7137H64.8311H64.8527C65.6569 31.1166 66.3149 30.9135 66.8293 30.502C67.3437 30.0931 67.7309 29.6003 67.9611 29.0046C68.1398 28.5416 68.1994 28.0813 68.1939 27.6346C68.1858 27.1282 68.091 26.6652 67.9178 26.2374C67.6362 25.547 67.0378 24.8646 66.4123 24.445ZM60.5693 20.7111L63.4421 20.7192C64.6822 20.7247 65.7192 21.9837 65.1695 23.1751C64.7878 24.0009 64.0892 24.3015 63.4746 24.315C62.619 24.334 61.4872 24.3231 60.5693 24.3231V20.7111ZM66.3338 28.3873C66.2228 28.6743 66.0414 28.9072 65.795 29.0994C65.5486 29.2916 65.2264 29.3891 64.8338 29.3891H60.572V25.9829H64.8338C65.2291 25.9829 65.5459 26.0533 65.7842 26.2374C66.0251 26.4243 66.193 26.6544 66.3121 26.9225C66.4042 27.1228 66.4611 27.3584 66.4611 27.6454C66.4611 27.9135 66.4204 28.1626 66.3338 28.3873Z",
    fill: "url(#paint1_linear_552_5687)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7157 29.8657L74.592 19.6092C74.4918 19.3628 74.3375 19.1949 74.0857 19.1055C73.8582 19.027 73.6389 19.0297 73.4196 19.1272C73.2003 19.2247 73.0487 19.3871 72.9647 19.6092L69.0522 29.9713C68.9683 30.196 68.9737 30.4154 69.0739 30.632C69.1714 30.8486 69.3338 30.9921 69.5613 31.0625C69.786 31.1329 70.008 31.1221 70.2273 31.03C70.4467 30.9379 70.5766 30.7782 70.6606 30.5589L71.4674 28.4415H76.2815L77.1074 30.4966C77.1967 30.7186 77.3429 30.873 77.5622 30.9569C77.7816 31.0408 78.0036 31.0544 78.2283 30.9786C78.4558 30.9 78.6128 30.7457 78.7048 30.5264C78.7969 30.3098 78.805 30.0877 78.7157 29.8657ZM72.1281 26.7032L73.8095 22.2924L75.583 26.7032H72.1281Z",
    fill: "url(#paint2_linear_552_5687)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1143 29.3891H53.0746C52.6793 29.3891 52.4193 29.3052 52.2921 29.1346C52.2081 29.0209 52.1486 28.8801 52.1134 28.7122C52.0782 28.5443 52.0538 28.3521 52.0403 28.1409V28.1192V19.9151C52.0403 19.6741 51.9563 19.471 51.7857 19.3004C51.6179 19.1325 51.4121 19.0459 51.1711 19.0459C50.9301 19.0459 50.7271 19.1298 50.5592 19.3004C50.3913 19.4683 50.3047 19.6741 50.3047 19.9151V28.1192V28.2248C50.3318 28.5903 50.3859 28.9369 50.4644 29.2618C50.543 29.5868 50.6783 29.8819 50.876 30.1499C51.1007 30.4613 51.3904 30.6996 51.7424 30.8702C52.0944 31.0381 52.5385 31.1247 53.0746 31.1247H57.1143C57.3553 31.1247 57.5584 31.0408 57.7289 30.8702C57.8968 30.7023 57.9834 30.4965 57.9834 30.2556C57.9834 30.0146 57.8995 29.8115 57.7289 29.6436C57.5584 29.473 57.3553 29.3891 57.1143 29.3891Z",
    fill: "url(#paint3_linear_552_5687)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9431 24.3801C33.8997 24.2962 33.8429 24.2176 33.7725 24.1472L36.3826 20.5596C36.5234 20.3619 36.5776 20.1453 36.5424 19.9125C36.5072 19.6796 36.3907 19.4928 36.1931 19.3493C35.9954 19.195 35.7788 19.1381 35.546 19.1787C35.3131 19.222 35.1236 19.3412 34.9828 19.5388L31.3735 24.483V20.1535C31.3735 19.9125 31.2896 19.7067 31.119 19.5388C30.9484 19.3682 30.7427 19.2843 30.5044 19.2843C30.2634 19.2843 30.0576 19.3682 29.8898 19.5388C29.7192 19.7094 29.6353 19.9152 29.6353 20.1535V30.5319C29.6353 30.7728 29.7192 30.9786 29.8898 31.1465C30.0603 31.3171 30.2634 31.401 30.5044 31.401C30.7454 31.401 30.9512 31.3171 31.119 31.1465C31.2896 30.9759 31.3735 30.7728 31.3735 30.5319V27.4343L32.6678 25.6716L35.5757 30.9136C35.6895 31.1248 35.8627 31.2629 36.0956 31.3279C36.3285 31.3929 36.5532 31.3658 36.7644 31.2548C36.9756 31.1411 37.1137 30.9678 37.1786 30.7349C37.2436 30.5021 37.2166 30.2773 37.1055 30.0662L33.9431 24.3801Z",
    fill: "url(#paint4_linear_552_5687)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84405 11.6594C9.98576 11.2831 15.7421 16.4384 16.9254 18.7074C17.0391 18.8997 16.9226 19.0513 16.6546 19.0026C13.9741 18.6506 9.4659 15.4122 8.81066 14.7841C7.91445 13.9934 7.36751 11.849 7.84405 11.6594Z",
    fill: "url(#paint5_linear_552_5687)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88752 8.21533C10.7413 8.26407 15.8614 15.5422 16.8226 18.7562C16.8686 18.8591 16.7224 18.9241 16.6358 18.8862C13.2675 17.7625 8.76207 13.0647 8.21243 12.2903C7.27018 11.0557 7.22686 8.34259 7.88752 8.21533Z",
    fill: "url(#paint6_linear_552_5687)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58586 3.65306C12.0543 4.51679 16.6383 14.4376 16.9118 18.6236C16.9388 18.7617 16.7412 18.7996 16.6491 18.7292C12.853 16.4115 8.3882 10.0268 7.88188 8.90047C7.06418 7.12154 7.7465 3.62056 8.58586 3.65306Z",
    fill: "url(#paint7_linear_552_5687)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1808 0.0165939C13.8578 2.08794 17.3343 12.7561 17.0717 18.4746C17.0825 19.0107 16.7766 19.008 16.6574 18.8753C12.1114 14.665 9.12488 7.3489 8.77018 5.69994C8.18263 3.09519 9.06802 -0.265001 10.1808 0.0165939Z",
    fill: "url(#paint8_linear_552_5687)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0268 20.9791C19.3491 22.3438 22.4384 22.0107 21.8888 20.8167C21.2633 19.4547 19.3572 17.7056 17.1397 16.5738C17.1045 16.5575 17.072 16.544 17.0368 16.5305C17.0882 17.2209 17.1017 17.8762 17.0747 18.4746C17.0801 18.6939 17.0314 18.8211 16.9637 18.8888C16.9393 18.9809 16.8283 19.035 16.655 19.0025C14.5458 18.7264 11.3075 16.6631 9.70186 15.4907C6.73704 16.0458 4.39767 17.9303 3.17383 20.8437C7.25419 18.591 11.386 19.1433 16.0268 20.9791Z",
    fill: "url(#paint9_linear_552_5687)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3199 28.0597C17.7486 30.2339 17.1475 31.7854 15.6746 33.3639C14.3181 34.8477 12.3496 36.1095 8.82433 36.3586C5.7187 36.5779 3.61218 35.0968 2.36398 33.1961C0.606741 30.5182 0.547177 24.4856 3.17085 20.8384C2.99215 20.9386 1.34592 22.3817 0.60945 24.3123C-0.00246946 25.964 -0.0376663 27.3773 0.0191934 29.075C0.097714 30.3639 0.376598 31.5986 0.823353 32.7493C0.831476 32.771 0.836888 32.7872 0.836888 32.7872C2.62391 37.3252 7.04814 40.5365 12.2197 40.5365C16.6439 40.5365 20.2288 38.4516 22.6656 34.6663C24.0167 32.5706 24.1846 31.3332 24.4445 29.7465C25.3218 24.4368 19.4706 23.6949 18.3199 28.0597Z",
    fill: "url(#paint10_linear_552_5687)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.1113 22.704C11.6754 22.7419 11.1013 22.9097 11.0499 23.6679C11.012 24.2175 11.6672 24.8836 12.7936 25.0244C13.8008 25.149 14.2909 25.677 14.5292 26.1914C14.67 26.4947 15.1276 26.4243 15.1655 26.0912C15.2169 25.6309 15.1546 25.1544 14.9624 24.6968C14.4804 23.565 13.2756 22.6038 12.1113 22.704Z",
    fill: "url(#paint11_linear_552_5687)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.4491 27.9946C13.6982 28.4414 13.5358 29.0045 13.089 29.2509C12.6423 29.5 12.0791 29.3376 11.8327 28.8908C11.5836 28.4441 11.7461 27.8809 12.1928 27.6345C12.6396 27.3881 13.2027 27.5478 13.4491 27.9946Z",
    fill: "url(#paint12_linear_552_5687)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.5986 31.8153C12.5986 34.0816 6.32237 37.2983 2.89454 33.2937C1.39181 31.3902 1.07773 29.5301 1.18874 29.4055C1.18062 29.4597 1.48658 31.8641 3.71494 32.4164C4.89275 32.7088 5.97579 32.1484 7.33501 31.1682C11.5832 28.1086 12.5959 30.9462 12.5986 31.8153Z",
    fill: "url(#paint13_linear_552_5687)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.802 30.4992C19.4058 33.5643 14.7108 37.9371 9.69636 37.9371C1.08347 37.9371 1.05369 30.4315 1.18636 29.4514C1.18636 29.4514 1.6277 31.7366 2.96255 32.9713C4.12953 33.8729 5.64579 34.4605 7.54923 34.095C12.8778 33.0769 13.1919 28.8882 16.154 28.6228C16.9338 28.5524 17.5024 28.7338 17.9085 29.0317C18.4446 29.4189 18.7046 30.0064 18.802 30.4992Z",
    fill: "url(#paint14_linear_552_5687)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7783 32.947H29.6299V38.7251H78.7783V32.947Z",
    fill: "url(#paint15_linear_552_5687)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0547 34.6069V35.0402H32.0989C31.6224 35.0402 31.4139 35.2784 31.4139 35.8443C31.4139 36.4075 31.6197 36.6458 32.0989 36.6458H33.0547V37.079H32.0989C31.3787 37.079 30.9834 36.6729 30.9834 35.8443C30.9834 35.0131 31.3814 34.6069 32.0989 34.6069H33.0547Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 34.3062V35.1455H34.6171C35.2696 35.1455 35.5918 35.4596 35.5918 35.9903V37.0788H35.1992V35.9903C35.1992 35.6952 35.0205 35.5192 34.6171 35.5192H33.9375V37.0788H33.5503V34.3089H33.9375V34.3062Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3734 35.1458C37.8581 35.1458 38.0476 35.4165 38.0476 35.7821V36.6891C38.0476 36.968 37.9745 37.0763 37.6496 37.0763H36.7453C36.2877 37.0763 36.0981 36.8543 36.0981 36.4861C36.0981 36.1341 36.2741 35.931 36.7507 35.931H37.6686V35.7848C37.6686 35.6359 37.5846 35.5167 37.3707 35.5167H36.2146V35.1431H37.3734V35.1458ZM37.6659 36.6025V36.2397H36.7534C36.5476 36.2397 36.4745 36.3236 36.4745 36.4671C36.4745 36.6106 36.5503 36.7027 36.7453 36.7027H37.5575C37.6361 36.7 37.6659 36.6729 37.6659 36.6025Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2055 35.1455V35.5192H39.136C38.9573 35.5192 38.8842 35.5923 38.8842 35.7385C38.8842 35.8739 38.9438 35.947 39.1577 35.947H39.6126C40.146 35.947 40.2813 36.1934 40.2813 36.4912C40.2813 36.8351 40.1026 37.0761 39.6478 37.0761H38.5241V36.6997H39.6478C39.8265 36.6997 39.8996 36.6374 39.8996 36.4885C39.8996 36.3342 39.8183 36.2719 39.6261 36.2719H39.1685C38.6351 36.2719 38.5024 36.0038 38.5024 35.7087C38.5024 35.3621 38.6811 35.1455 39.1333 35.1455H40.2055Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1314 34.4172V34.8667H40.7388V34.4172H41.1314ZM41.1287 35.1456V37.0788H40.7415V35.1456H41.1287Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7536 35.1455C43.4088 35.1455 43.7283 35.4569 43.7283 35.9903V37.0788H43.3357V35.9903C43.3357 35.687 43.1597 35.5192 42.7536 35.5192H42.12C42.0875 35.5192 42.0713 35.5381 42.0713 35.5733V37.0788H41.6841V35.4461C41.6841 35.2186 41.7599 35.1455 41.9548 35.1455H42.7536Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5532 35.1455C46.0135 35.1455 46.2626 35.4163 46.2626 35.9741V37.0869C46.2626 37.6366 46.0731 37.8532 45.5315 37.8532H44.3808V37.4795H45.4855C45.7752 37.4795 45.87 37.3658 45.87 37.0869V36.9975H45.0171C44.4999 36.9975 44.1777 36.6943 44.1777 36.0688C44.1777 35.4461 44.4999 35.1455 45.0171 35.1455H45.5532ZM45.055 36.6456H45.87V35.9686C45.87 35.6545 45.7481 35.5192 45.4368 35.5192H45.0523C44.7193 35.5192 44.5676 35.687 44.5676 36.0824C44.573 36.4777 44.722 36.6456 45.055 36.6456Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4872 34.6069V35.0402H48.767V37.079H48.3311V35.0402H47.6108V34.6069H49.4872Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2588 34.3062V35.1455H50.9384C51.5909 35.1455 51.9131 35.4596 51.9131 35.9903V37.0788H51.5205V35.9903C51.5205 35.6952 51.3418 35.5192 50.9384 35.5192H50.2588V37.0788H49.8716V34.3089H50.2588V34.3062Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7162 35.1455C54.1737 35.1455 54.3687 35.3648 54.3687 35.7385C54.3687 36.0932 54.19 36.2936 53.7134 36.2936H52.7956V36.4317C52.7956 36.586 52.8795 36.6997 53.0907 36.6997H54.2739V37.0761H53.0907C52.6087 37.0761 52.4165 36.8053 52.4165 36.4398V35.7818C52.4165 35.4163 52.606 35.1455 53.0907 35.1455H53.7162ZM52.7956 35.9903H53.7026C53.9111 35.9903 53.9869 35.9037 53.9869 35.7601C53.9869 35.6139 53.903 35.5192 53.7134 35.5192H53.0907C52.8795 35.5192 52.7956 35.6356 52.7956 35.7872V35.9903Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.759 34.6069V35.0402H56.7626C56.37 35.0402 56.2535 35.227 56.2535 35.4571V35.6927H57.7427V36.1016H56.2535V37.079H55.8203V35.4598C55.8203 34.9643 56.0775 34.6069 56.7328 34.6069H57.759Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 34.3062V37.0761H58.249V34.3062H58.6362Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2137 35.1455L60.0494 37.8532H59.6325L59.9953 37.0084C59.776 37.0084 59.7002 36.938 59.6325 36.7701L58.9854 35.1455H59.3942L59.9763 36.5833C60.0007 36.6537 60.0197 36.6645 60.0928 36.6645H60.1442L60.7994 35.1455H61.2137Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9531 34.4172V34.8667H61.5605V34.4172H61.9531ZM61.9477 35.1456V37.0788H61.5605V35.1456H61.9477Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5749 35.1455C64.2301 35.1455 64.5496 35.4569 64.5496 35.9903V37.0788H64.157V35.9903C64.157 35.687 63.981 35.5192 63.5749 35.5192H62.9413C62.9088 35.5192 62.8926 35.5381 62.8926 35.5733V37.0788H62.5054V35.4461C62.5054 35.2186 62.5812 35.1455 62.7761 35.1455H63.5749Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3721 35.1455C66.8323 35.1455 67.0814 35.4163 67.0814 35.9741V37.0869C67.0814 37.6366 66.8919 37.8532 66.3504 37.8532H65.1997V37.4795H66.3044C66.5941 37.4795 66.6888 37.3658 66.6888 37.0869V36.9975H65.8359C65.3188 36.9975 64.9966 36.6943 64.9966 36.0688C64.9966 35.4461 65.3188 35.1455 65.8359 35.1455H66.3721ZM65.8766 36.6456H66.6916V35.9686C66.6916 35.6545 66.5697 35.5192 66.2583 35.5192H65.8739C65.5408 35.5192 65.3892 35.687 65.3892 36.0824C65.3919 36.4777 65.5435 36.6456 65.8766 36.6456Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5387 34.6069V35.0402H69.5423C69.1497 35.0402 69.0333 35.227 69.0333 35.4571V35.6927H70.5225V36.1016H69.0333V37.079H68.6001V35.4598C68.6001 34.9643 68.8573 34.6069 69.5126 34.6069H70.5387Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.419 34.4172V34.8667H71.0264V34.4172H71.419ZM71.4163 35.1456V37.0788H71.0291V35.1456H71.4163Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.582 35.1455V35.5192H72.5125C72.3338 35.5192 72.2607 35.5923 72.2607 35.7385C72.2607 35.8739 72.3202 35.947 72.5342 35.947H72.989C73.5224 35.947 73.6578 36.1934 73.6578 36.4912C73.6578 36.8351 73.4791 37.0761 73.0242 37.0761H71.9006V36.6997H73.0242C73.2029 36.6997 73.276 36.6374 73.276 36.4885C73.276 36.3342 73.1948 36.2719 73.0026 36.2719H72.545C72.0116 36.2719 71.8789 36.0038 71.8789 35.7087C71.8789 35.3621 72.0576 35.1455 72.5098 35.1455H73.582Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5054 34.3062V35.1455H75.185C75.8375 35.1455 76.1597 35.4596 76.1597 35.9903V37.0788H75.7671V35.9903C75.7671 35.6952 75.5884 35.5192 75.185 35.5192H74.5054V37.0788H74.1182V34.3089H74.5054V34.3062Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_5687",
    x1: 28.4716,
    y1: 25.2867,
    x2: 78.1106,
    y2: 25.2867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_552_5687",
    x1: 28.4713,
    y1: 25.0858,
    x2: 78.1104,
    y2: 25.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_552_5687",
    x1: 28.4714,
    y1: 25.0771,
    x2: 78.1104,
    y2: 25.0771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_552_5687",
    x1: 28.4713,
    y1: 25.0858,
    x2: 78.1103,
    y2: 25.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_552_5687",
    x1: 30.0094,
    y1: 25.2868,
    x2: 79.6484,
    y2: 25.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_552_5687",
    x1: 7.13496,
    y1: 13.3518,
    x2: 17.5701,
    y2: 17.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_552_5687",
    x1: 6.53765,
    y1: 11.3364,
    x2: 18.018,
    y2: 15.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_552_5687",
    x1: 6.26878,
    y1: 8.79776,
    x2: 18.8492,
    y2: 13.5279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_552_5687",
    x1: 6.83893,
    y1: 6.98345,
    x2: 19.6541,
    y2: 11.8018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_552_5687",
    x1: 3.17318,
    y1: 18.6784,
    x2: 21.9507,
    y2: 18.6784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_552_5687",
    x1: 0.00105222,
    y1: 30.6918,
    x2: 24.5368,
    y2: 30.6918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_552_5687",
    x1: 11.0468,
    y1: 24.5411,
    x2: 15.1808,
    y2: 24.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_552_5687",
    x1: 11.718,
    y1: 28.4427,
    x2: 13.5666,
    y2: 28.4427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_552_5687",
    x1: 1.16873,
    y1: 32.3,
    x2: 12.5978,
    y2: 32.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_552_5687",
    x1: 1.16237,
    y1: 33.2744,
    x2: 18.8553,
    y2: 33.2744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_552_5687",
    x1: 29.6311,
    y1: 35.8362,
    x2: 78.7792,
    y2: 35.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B569C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKolba);
export default __webpack_public_path__ + "static/media/kolba.47fd95a2650df08c4cf9c762c2ded558.svg";
export { ForwardRef as ReactComponent };